import { AsyncState, Updater, loadingAsyncState, unloadedAsyncState } from 'widgets-for-react'
import { GetCMSPage, GetEventTemplateByEventId, getData } from '../../../../utils/api'
import { EventTemplate } from '../../../models/Events/Events'
import { EventPageData } from '../../sharepointPageApi/types/pageData'
import { transformEventPageData } from '../../sharepointPageApi/transformers/pageDataToPage'
import { EventPage } from '../../cmsPageState'

export interface EventDetailsState {
  eventId: string | null
  pageData: EventPage
  eventData: AsyncState<EventTemplate>
}

export const initialEventDetailsState = (pageData: EventPage, eventId: string | null): EventDetailsState => ({
  eventId: eventId,
  pageData: pageData,
  eventData: eventId ? loadingAsyncState(() => getData<EventTemplate>(GetEventTemplateByEventId(eventId))) : unloadedAsyncState(),
})

export const EventDetailsStateUpdaters = {
  updateEventData: (u: Updater<AsyncState<EventTemplate>>): Updater<EventDetailsState> => s0 => ({ ...s0, eventData: u(s0.eventData) }),
}
